import { motion } from 'framer-motion';
import { FaBullseye, FaLightbulb } from 'react-icons/fa'; // Icons for Mission and Vision

const AboutSection = () => {
  return (
    <div className="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white p-8 md:p-8 lg:p-16 shadow-lg">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {/* Left Content */}
        <div>
          <h1 className="text-2xl sm:text-4xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">
            About Hither Tech
          </h1>
          <p className="text-gray-300 mb-4">
            Founded in 2014 by a team of UK University of Greenwich alumni, Hither Tech Ltd has grown into a global enterprise solutions provider. With years of experience in the European and US marketplaces, we offer a comprehensive range of IT services, including software development, hardware solutions, and internet services.
          </p>
          <p className="text-gray-300">
            Our commitment to innovation and excellence enables us to deliver customized solutions for businesses of all sizes.
          </p>
        </div>

        {/* Right Image */}
        <div className="flex justify-center">
          <motion.img
            src="/images/about-image.jpg"
            alt="Careers at Hither Tech"
            className="w-full max-w-md rounded-lg shadow-lg"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          />
        </div>
      </div>

      {/* Mission and Vision Section */}
      <div className="grid md:grid-cols-2 gap-8 mt-12">
        {/* Mission Section */}
        <motion.div
          className="bg-gray-900 border border-blue-600 rounded-lg p-6 shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center mb-4">
            <FaBullseye className="text-blue-600 text-4xl mr-4" />
            <h2 className="text-3xl font-bold">Our Mission</h2>
          </div>
          <p className="text-gray-300 leading-relaxed">
            We believe in delivering quality-driven solutions that empower businesses to thrive in a competitive digital landscape.
          </p>
        </motion.div>

        {/* Vision Section */}
        <motion.div
          className="bg-gray-900 border border-purple-600 rounded-lg p-6 shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="flex items-center mb-4">
            <FaLightbulb className="text-purple-600 text-4xl mr-4" />
            <h2 className="text-3xl font-bold">Our Vision</h2>
          </div>
          <p className="text-gray-300 leading-relaxed">
            To be a global leader in technology solutions, fostering innovation and driving digital transformation for businesses worldwide.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutSection;